export const ESPACENET = 'ESPACENET';
export const USPTO = 'USPTO';
export const LLS_RESPONSE_LOCATION_VALUE = 'location-value';
export const elsevierExternalUrlStrings = [
  'pid=scp:',
  'https://lls.rx-nonprod.cm-elsevier.com/redir',
  'https://www.sciencedirect.com',
  'https://www.scopus.com',
  'https://linkinghub.elsevier.com',
];
export const DOI_URL = 'https://doi.org/';
export const TABLE_COLUMNS_SWITCHER_COUNT_OF_COLUMNS_BY_CONTAINER_WIDTH = [
  {
    count: 4,
    interval: [1, 714], // 1-1279  (3 + <> + last)
  },
  {
    count: 6,
    interval: [715, 874], // 1280-1439 (5 + <> + last)
  },
  {
    count: 8,
    interval: [875, 1114], // 1440-1679 (7 + <> + last)
  },
  {
    count: 100,
    interval: [1115, 99999], // 1680-9999 (all)
  },
];
